import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { AuthService } from "src/app/_services/auth.service";
import { NavigationService } from "src/app/_services/navigation-service.service";

@Component({
  selector: "app-verify-code",
  templateUrl: "./verify-code.page.html",
  styleUrls: ["./verify-code.page.scss"],
})
export class VerifyCodePage implements OnInit {
  submitted: boolean = false;

  verifyCodeForm: any;
  emailParams: any;
  code: string = "";
  errorMessage: string = "invalide code";
  validCode: boolean = false;
  isLoading: boolean = false;
  constructor(
    private navController: NavController,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.emailParams = params["email"];
    });
  }

  onCodeChanged(code: string) {
    this.code = code;
    this.submitted = false;

    if (code.length === 6) {
      this.validCode = true;
    } else {
      this.validCode = false;
    }
  }

  onCodeCompleted(code: string) {}
  // backto() {
  //   this.navController.pop();
  // }
  backto() {
    this.navigationService.goToPreviousPage();
  }
  submitForm() {
    this.submitted = true;
    this.isLoading = true;

    let formData = {
      email: this.emailParams,
      otp: this.code,
    };

    this.authService.verifCode(formData).subscribe(
      (res: any) => {
        let error = res.body.error;
        if (error) {
          this.errorMessage = "invalide code";
          this.isLoading = false;
          this.validCode = false;
        } else {
          this.isLoading = false;
          this.router.navigate(["/reintialiser-mot-de-passe"], {
            state: {
              email: this.emailParams,
            },
          });
        }
      },
      (errors: HttpErrorResponse) => {
        this.validCode = false;
        this.isLoading = false;
        this.errorMessage = "invalide code";
        if (errors.status === 401 || errors.status === 403) {
        } else {
          console.error("An error occurred:", errors.error);
          if (errors.error && errors.error.message) {
            console.error("Error message:", errors.error.message);
          } else {
            console.error("Unknown error occurred");
          }
        }
      }
    );
  }
  resendCode() {
    this.authService
      .forgotPassword({ email: this.emailParams })
      .subscribe((res: any) => {
        if (res.status === 200) {
        }
      });
  }
}
